import { render, staticRenderFns } from "./Ywfzqkdj.vue?vue&type=template&id=437bdaca"
import script from "./Ywfzqkdj.vue?vue&type=script&lang=js"
export * from "./Ywfzqkdj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports